/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { SignInPageService } from '@pages/SignIn/services';
import toast from 'react-hot-toast';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

export const getSignInType = async (context: any, event: any) => {
  const currentState = 'GET_SIGN_IN_TYPE';
  const method = 'getSignInType';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getSignInType(event?.payload);
      if (content && content?.signInType) {
        return resolve({
          key: 'GET_SIGN_IN_TYPE_SUCCESS',
          value: {
            ...(content || {}),
            email: event?.payload?.email,
          },
        });
      } else {
        const msg = content?.error?.replace('UnauthorizedError:', '');
        log.error(`error in ${method}, msg: ${msg}`);
        toast.error(msg);
        return reject({
          key: 'GET_SIGN_IN_TYPE_FAILURE',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'GET_SIGN_IN_TYPE_FAILURE',
        value: err?.message,
      });
    }
  });
};
